import { useCallback, useEffect, useState } from 'react';

/**
 * Inline source markers (<sup class="source-reference">): hover tooltip and the
 * source drawer opened on click. Listeners are attached to `document`.
 */
export function useSourceReferenceTooltip() {
  const [tooltipContent, setTooltipContent] = useState('');
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedSource, setSelectedSource] = useState('');
  const [, setSelectedCitation] = useState('');

  const handleSourceClick = useCallback((event) => {
    const sourceRef = event.target.closest('.source-reference');
    if (sourceRef) {
      const sourceNum = sourceRef.dataset.source;
      const itemNum = sourceRef.dataset.item;
      const fullInfo = sourceRef.dataset.fullInfo;

      // Set the necessary data for the drawer
      setSelectedSource(`${sourceNum}:${itemNum}†${fullInfo}`);
      setSelectedCitation(`Citation from source ${sourceNum}, item ${itemNum}`);
      setDrawerOpen(true);

      // Clear any tooltip that might be showing
      setTooltipContent('');
    }
  }, []);

  const handleSourceHover = useCallback((event) => {
    const sourceRef = event.target.closest('.source-reference');
    if (sourceRef) {
      const fullInfo = sourceRef.dataset.fullInfo;
      setTooltipContent(fullInfo);
      const rect = sourceRef.getBoundingClientRect();
      setTooltipPosition({ x: rect.right + 5, y: rect.top });
    } else {
      setTooltipContent('');
    }
  }, []);

  useEffect(() => {
    // Add both click and hover handlers
    document.addEventListener('click', handleSourceClick);
    document.addEventListener('mouseover', handleSourceHover);

    return () => {
      // Remove both handlers on cleanup
      document.removeEventListener('click', handleSourceClick);
      document.removeEventListener('mouseover', handleSourceHover);
    };
  }, [handleSourceClick, handleSourceHover]);

  return {
    tooltipContent,
    tooltipPosition,
    drawerOpen,
    setDrawerOpen,
    selectedSource,
  };
}
